import { atom, selector } from "recoil"

import { designDiffState } from "./designs/design-state"
import { proposalDiffState } from "./proposal/proposal-state"
import { siteDiffState } from "./site/site-state"

export const editingState = selector<boolean>({
  key: `editing`,
  get: ({ get }) => {
    const siteIsDirty = Boolean(get(siteDiffState))
    const proposalIsDirty = Boolean(get(proposalDiffState))
    const designIsDirty = Boolean(get(designDiffState))

    return siteIsDirty || proposalIsDirty || designIsDirty
  },
})

export const overviewMinimizedState = atom<boolean>({
  key: `overviewMinimized`,
  default: false,
})
